module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "keywords": _vm.keyword,
      "isSearch": _vm.path
    },
    on: {
      "tosearch": _vm.tosearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scontent-view"
  }, [_c('div', {
    staticClass: "conwidth marginauto lall animated list-view"
  }, [_vm._l((_vm.list), function(item, index) {
    return [(item.type == '1') ? _c('div', {
      staticClass: "list-item"
    }, [_c('el-tag', {
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(" 创业服务 ")]), _vm._v("\n                    " + _vm._s(item.data.name) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.type == '2') ? _c('div', {
      staticClass: "list-item"
    }, [_c('el-tag', {
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(" 政策服务 ")]), _vm._v("\n                    " + _vm._s(item.data.name) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.type == '3') ? _c('div', {
      staticClass: "list-item"
    }, [_c('el-tag', {
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(" 活动资讯 ")]), _vm._v("\n                    " + _vm._s(item.data.name) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.type == '4') ? _c('div', {
      staticClass: "list-item"
    }, [_c('el-tag', {
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v("场地服务 ")]), _vm._v("\n                    " + _vm._s(item.data.title) + "\n                ")], 1) : _vm._e(), _vm._v(" "), (item.type == '5') ? _c('div', {
      staticClass: "list-item"
    }, [_c('el-tag', {
      attrs: {
        "effect": "dark"
      }
    }, [_vm._v(" 在孵化企业 ")]), _vm._v("\n                    " + _vm._s(item.data.shop_name) + "\n                ")], 1) : _vm._e()]
  })], 2), _vm._v(" "), (!_vm.list.length) ? _c('div', {}, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a6e4876"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/searchpage.vue
// module id = 385
// module chunks = 1